import { defineNuxtPlugin } from '#app/nuxt'
import { LazyBaseNavigationDropdown, LazyTensorLogo, LazyTensorLogoText, LazyBaseLink, LazyBasePage, LazyTairoLogo, LazyTairoLogoText, LazyTairoToaster, LazyTairoTocAnchor, LazyIcon } from '#components'
const lazyGlobalComponents = [
  ["BaseNavigationDropdown", LazyBaseNavigationDropdown],
["TensorLogo", LazyTensorLogo],
["TensorLogoText", LazyTensorLogoText],
["BaseLink", LazyBaseLink],
["BasePage", LazyBasePage],
["TairoLogo", LazyTairoLogo],
["TairoLogoText", LazyTairoLogoText],
["TairoToaster", LazyTairoToaster],
["TairoTocAnchor", LazyTairoTocAnchor],
["Icon", LazyIcon],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
